import { IAdminGroup } from '../../../../../store/admin/groups/store';
import { IAdminMembership } from '../../../../../store/admin/memberships/store';

export const getSelectedMembers = (
  memberships: IAdminMembership[],
  selectedGroups: {
    [key: number]: boolean;
  },
  isActiveSelected: boolean,
  isGuestSelected: boolean
): IAdminMembership[] => [
  ...memberships.reduce((acc: IAdminMembership[], membership: IAdminMembership) => {
    const someMemberGroupIsSelected = membership.groups.some(
      (group: IAdminGroup) => selectedGroups[group.id]
    );
    const isActiveAndActiveIsSelected = isActiveSelected && membership.status === 'active';
    const isGuestAndGuestIsSelected = isGuestSelected && membership.status !== 'active';

    return someMemberGroupIsSelected || isActiveAndActiveIsSelected || isGuestAndGuestIsSelected
      ? [...acc, membership]
      : acc;
  }, [])
];
